export default "__VITE_ASSET__BEFAIZ7f__"